import config from '../data/config.json';

import txobj from '../data/taxons.json';
//import wdquery from '../data/wdquery.json';

import { parse } from 'wkt';
import { saveAs } from 'file-saver';

import { Datos, Crafts, Sesion } from '../main.js';
import { getMapLayer } from './map.js';
import { pintarTeselas } from './patches.js';
import { pintarParcelas } from './plots.js';
import { pintarArboles } from './trees.js';
import { getAllSubclasses } from './util.js';
import { getCeldaBounds, getCeldaGridMatrix } from './grid.js';

const MAX_HILOS = 8; // número máximo de peticiones a la red o a la Cache API

/////////
// UTILES
function descomponerCraftsResources(id, uris) {
	// array a devolver con la descomposición
	let devolver = [];
	// array de huérfanos (para combinar)
	let huerfanos = [];

	// organizo las uris por sus namespaces
	let nsuris = {};
	// analizo cada uri y la meto por su namespace
	for (let uri of uris) {
		// si no es un string me salgo
		if (typeof uri != "string")
			continue;	
		// obtengo namespace
		const indfin = Math.max( uri.lastIndexOf('/'), uri.lastIndexOf('#') );
		const ns = uri.substring(0, indfin + 1);
		// guardo
		if (nsuris[ns] == undefined)
			nsuris[ns] = [];
		nsuris[ns].push(uri);
	}
	
	// analizo cada namespace encontrado
	const nss = Object.keys(nsuris);
	for (let i=0; i<nss.length; i++) {
		// obtengo el namespace y sus uris
		const mins = nss[i];
		const misuris = nsuris[mins];
		// preparo lotes de 200
		const lote = 200;
		for (let ind=0; misuris.length > ind*lote; ind++) {
			const begin = ind*lote;
			const end = misuris.length > (ind + 1)*lote? (ind + 1)*lote : misuris.length;
			// si este lote es inferior a 10, los meto en huérfanos
			if (end - begin < 10) 
				huerfanos = huerfanos.concat( misuris.slice( begin, end ) );
			else {
				// creo un objeto para este lote
				let obj = {};
				obj.id = id;
				obj.ns = mins;
				obj.nspref = 'p'; // arbitrario
				obj.iris = [];
				// meto cada iri con prefijo en el lote
				for (let j=begin; j<end; j++) {
					const uri = misuris[j];
					const prefuri = 'p:' + uri.substring(mins.length);
					obj.iris.push(prefuri);				
				}
				// y guardo el objeto en devolver
				devolver.push(obj);
			}
		}
	}
	
	// proceso los huérfanos en lotes de 40
	const lote = 40;
	for (let ind=0; huerfanos.length > ind*lote; ind++) {
		const begin = ind*lote;
		const end = huerfanos.length > (ind + 1)*lote? (ind + 1)*lote : huerfanos.length;
		// creo un objeto para este lote
		let obj = {};
		obj.id = id;
		obj.iris = huerfanos.slice( begin, end );
		// y guardo el objeto en devolver
		devolver.push(obj);
	}
		
	// devuelvo la descomposición
	return devolver;
}
// extraigo un objeto con el mapeo de urls cacheadas a iris de un id determinado
function getCachedObjectMapping(id, iris) {
	// inicializo las cosas a retornar
	const objcache = {}; // el objeto de resultados: url cacheada a array de iris
	const pendingiris = [];  // las iris no cacheadas
	for (const iri of iris) {
		const curl = Crafts.getCacheUrl(id, iri);
		if (!curl) // no se encontró
			pendingiris.push(iri); 
		else { // la guardo con la url de la caché
			if (!objcache[curl])
				objcache[curl] = [];
			objcache[curl].push(iri);
		}
	}
	return [objcache, pendingiris];
}
// cacheando ad hoc
function cacheandoAdhoc(id, objcachear) {
	// extraigo uris
	const uris = Object.keys(objcachear);
	if (uris.length == 0)
		return; // nada que guardar
	// organizo las uris por sus namespaces
	let nsuris = {};
	// analizo cada uri y la meto por su namespace
	for (let i=0; i<uris.length; i++) {
		const uri = uris[i];
		// obtengo namespace
		const indfin = Math.max( uri.lastIndexOf('/'), uri.lastIndexOf('#') );
		const ns = uri.substring(0, indfin + 1);
		// guardo
		if (!nsuris[ns])
			nsuris[ns] = [];
		nsuris[ns].push(uri);
	}
	
	// analizo cada namespace encontrado
	const nss = Object.keys(nsuris);
	for (let i=0; i<nss.length; i++) {
		// obtengo el namespace y sus uris
		const mins = nss[i];
		const misuris = nsuris[mins];
		
		// sin lotes
		// preparo la url y el objeto a guardar
		let url = config.craftsConfig.api + "/object?id=" + id;
		const objguardar = {};
		for (let uri of misuris) {
			url += '&i=p:' + uri.substring(mins.length);
			objguardar[uri] = objcachear[uri];
		}
		// completo la url
		url += "&ns=" + mins + "&nspref=i";			
		// guardo en la caché
		Crafts.cacheandoAdhoc(url, objguardar);
	}
}
// util para usos y taxones
function initClass(objbase, cluri) {
	if (!objbase[cluri]) {
		objbase[cluri] = {
			"uri": cluri, 
			"subclasses": [], 
			"superclasses": []
		};
	}
}

//////////////////////////////////////
// INICIALIZACIONES PROVEEDOR DE DATOS
// obtengo todos los usos para las teselas
async function getUsesInfo() {	
	// miro si están los usos en la caché
	const usosurl = config.craftsConfig.api + "/object?id=misusos";
	await Crafts.getCacheData(usosurl).then(data => {
		// guardo 
		Datos.usos = data;		
    })
    .catch(async error => {
  		console.debug("No están los usos en la caché...");
  			
		// obtengo pares de superclase-subclase de los usos (NO CACHEABLE)
		const datos = await Crafts.getData(config.craftsConfig.queryNopars, 
			{ queryName: "useSubclasses" }, true);
		// analizo cada fila de los resultados
		for (let row of datos.results.bindings) {
			// obtengo datos
			const supuri = row.sup.value;
			const suburi = row.sub.value;
			// inicializo clases
			initClass(Datos.usos, supuri);
			initClass(Datos.usos, suburi);
			// guardo subclase
			Datos.usos[supuri].subclasses.push(suburi);
			// guardo superclase
			Datos.usos[suburi].superclasses.push(supuri);
		}
		// obtengo usos expandidos
		let evuuris = Object.keys(Datos.usos);
		while(evuuris.length > 0) {
			let newevuuris = [];
			for (let uuri of evuuris) {
				// recupero uso
				const uso = Datos.usos[uuri];
				// obtengo la uri de cualquier subuso sin expandir
				const algsubuuri = uso.subclasses.find(subuuri => Datos.usos[subuuri].expuris === undefined);
				// si no está definida, puedo hacer la expansión de uris
				if (algsubuuri == undefined) {
					// inicializo con la uri del propio uso
					uso.expuris = [uuri];
					// y ahora incluimos las de la subclases
					for (let subuuri of uso.subclasses)
						uso.expuris = [...new Set([...uso.expuris, ...Datos.usos[subuuri].expuris])];
				}
				else // hay que esperar a la siguiente iteración
					newevuuris.push(uuri);
			}
			// actualizo lista de tipos a evaluar
			evuuris = newevuuris;
		}
		
		// obtengo los usos
		const uuris = Object.keys(Datos.usos);
	
		// ahora obtengo la información de cada uso
	
		// inicializo las promesas
		let promesas = [];
	
		// pido descomponer en objetos para la llamada resources de CRAFTS
		const objrs = descomponerCraftsResources('Use', uuris); 
		// ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS
		for (let objr of objrs) {
			// creo una promesa para cada petición
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)
					let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
					// convierto en array si es necesario
					if (!Array.isArray(datos))
						datos = [ datos ];
					// actualizo uso a uso
					for (let dato of datos)
						Object.assign(Datos.usos[dato.iri], dato);
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}	
		// espero a que terminen todas las promesas
		await Promise.all(promesas);	
	
		// guardo en la caché		
		Crafts.cacheandoAdhoc(usosurl, Datos.usos);
    });	
}
	

// info de todos los taxones
async function getTaxonsInfo() {
	// miro si están los taxones en la caché
	const txurl = config.craftsConfig.api + "/object?id=mistaxones";
	await Crafts.getCacheData(txurl).then(data => {
		// guardo 
		Datos.taxones = data;		
    })
    .catch(async error => {
  		console.debug("No están los taxones en la caché...");
  		
  		// 13/5/2026 debido al problema con Wikidata, leo directamente del fichero
		//console.time("Carga taxones de fichero");
		Datos.taxones = txobj;
		// guardo en la caché
		Crafts.cacheandoAdhoc(txurl, Datos.taxones);
		//console.timeEnd("Carga taxones de fichero");
		
		
  		/*
  		// procesamiento anterior para extraer los datos de los endpoints
  		// obtengo info de subclases de los taxones a partir de plantae
		// preparo objeto para la petición a CRAFTS de pares de superclase-subclase a partir de config.txPlantae
		const qobj = { 'ancestor': config.txPlantae };
		const datos = await Crafts.getData(config.craftsConfig.querySubclasses, qobj, true); // (NO CACHEABLE)
		// fue todo bien, inicializo clase de plantae
		initClass(Datos.taxones, config.txPlantae);
		// analizo cada fila de los resultados
		for (let row of datos.results.bindings) {
			// obtengo datos
			const supuri = row.sup.value;
			const suburi = row.sub.value;
			// inicializo clases
			initClass(Datos.taxones, supuri);
			initClass(Datos.taxones, suburi);
			// guardo subclase
			Datos.taxones[supuri].subclasses.push(suburi);
			// guardo superclase
			Datos.taxones[suburi].superclasses.push(supuri);
		}
		// obtengo taxones expandidos
		let evsuris = Object.keys(Datos.taxones);
		while(evsuris.length > 0) {
			let newevsuris = [];
			for (let suri of evsuris) {
				// recupero taxon
				const taxon = Datos.taxones[suri];
				// obtengo la uri de cualquier subespecie sin expandir
				const algsubsuri = taxon.subclasses.find(subsuri => Datos.taxones[subsuri].expuris === undefined);
				// si no está definida, puedo hacer la expansión de uris
				if (algsubsuri == undefined) {
					// inicializo con la uri de la propia taxon
					taxon.expuris = [suri];
					// y ahora incluimos las de la subclases
					for (let subsuri of taxon.subclasses)
						taxon.expuris = [...new Set([...taxon.expuris, ...Datos.taxones[subsuri].expuris])];
				}
				else // hay que esperar a la siguiente iteración
					newevsuris.push(suri);
			}
			// actualizo lista de tipos a evaluar
			evsuris = newevsuris;
		}
		// obtengo taxones expandidos superiores
		evsuris = Object.keys(Datos.taxones);
		while(evsuris.length > 0) {
			let newevsuris = [];
			for (let suri of evsuris) {
				// recupero taxon
				const taxon = Datos.taxones[suri];
				// obtengo la uri de cualquier supertaxon sin expandir
				const algsupersuri = taxon.superclasses.find(supersuri => Datos.taxones[supersuri].superexpuris === undefined);
				// si no está definida, puedo hacer la expansión de uris
				if (algsupersuri == undefined) {
					// inicializo con la uri de la propia taxon
					taxon.superexpuris = [suri];
					// y ahora incluimos las de la superclases
					for (let supersuri of taxon.superclasses)
						taxon.superexpuris = [...new Set([...taxon.superexpuris, ...Datos.taxones[supersuri].superexpuris])];
				}
				else // hay que esperar a la siguiente iteración
					newevsuris.push(suri);
			}			
			// actualizo lista de tipos a evaluar
			evsuris = newevsuris;
		}
	
		// obtengo el número de individuos directos de cada especie
		const suris = Object.keys(Datos.taxones); 
		// inicializo a 0 el número de individuos por cada versión de inventario
		for (let suri of suris) {
			Datos.taxones[ suri ].indivs = {};
			for (let ifn of config.ifnVersions) 
				Datos.taxones[suri].indivs[ifn] = { 'count': 0 };		
		}
	
		// extraigo el número de individuos directos de cada taxón con queryCountTreesPerTaxon (para los diferentes ifn)
		for (let ifn of config.ifnVersions) {		
			// preparo objeto para la petición a CRAFTS con la versión del ifn
			const qobj = { 'ifn': ifn };
			const datos = await Crafts.getData(config.craftsConfig.queryCountTreesPerTaxon, qobj, true); // (NO CACHEABLE)	
			// analizo fila a fila
			for (let row of datos.results.bindings) {
				// obtengo datos
				const cluri = row.tx.value;
				const count = Number(row.ntrees.value);
				// guardo sólo si existe
				if (Datos.taxones[cluri] != undefined && Datos.taxones[cluri].indivs[ifn] != undefined)
					Datos.taxones[cluri].indivs[ifn].count = count;
			}
		}
		// calculo suma de todos los individuos por edición del ifn (incluyo los de las subclases)
		for (let suri of suris) {
			for (let ifn of config.ifnVersions) {
				let nindivs = Datos.taxones[suri].indivs[ifn].count; // los directos
				// sumo los individuos de las subclases
				const suburis = getAllSubclasses(suri, Datos.taxones);
				for (let suburi of suburis)
					nindivs += Datos.taxones[suburi].indivs[ifn].count;
				// guardo la suma de todos
				Datos.taxones[suri].indivs[ifn].countALL = nindivs;
			}
		}
	
		// ahora obtengo la información de cada taxón
		// para los taxones pendientes hago la llamada a CRAFTS
		// pero no hago las peticiones en paralelo para no inundar a Wikidata
	
		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs = descomponerCraftsResources('Species', suris);
		// ya tengo los objetos a pedir, lanzo las peticiones en secuencia a CRAFTS
		for (const objr of objrs) {
			// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)	
			let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
			// convierto en array si es necesario
			if (!Array.isArray(datos))
				datos = [ datos ];
			// actualizo taxon a taxon
			for (let dato of datos)
				Object.assign(Datos.taxones[dato.iri], dato);
		}
		
		
		
  		// 13/5/2026 	NUEVA EXTRACCIÓN DEBIDO A LOS PROBLEMAS CON WIKIDATA
  		
		// extracción de las IRIs de Wikidata, ahora trabajaremos con ellas
		//const wds = [...new Set(
		//	Object.values(Datos.taxones).map(item => item.wikidata)
		//)];
		//const blobwds =  new Blob([JSON.stringify(wds, null, 2)], {type: "text/plain;charset=utf-8"});
		//saveAs(blobwds, "wds.json");
		
		// preparo un objeto con las entidades de Wikidata
		const wikients = {};
		// inicialización de opciones
		const options = {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		};
		// trabajo con la consulta
		// tarda bastante porque las peticiones se hacen en secuencia 
		// (no importa porque sólo lo haremos una vez para preparar el fichero)
		for (const binding of wdquery.results.bindings) {
			//console.log(binding.tx.value);			
			const tx = binding.tx.value;
			const txobj = {
				wikipedia : { "en" : binding.wikipediaEN.value },
				images : []
			};
			if (binding.wikipediaES)
				txobj.wikipedia.es = binding.wikipediaES.value;
			if (binding.wikispecies)
				txobj.wikispecies = binding.wikispecies.value;
			if (binding.gbif)
				txobj.gbif = binding.gbif.value;
			// aquí extraigo los datos de la API de wikimedia
			// inglés
			const titen = txobj.wikipedia.en.slice(txobj.wikipedia.en.lastIndexOf("/") + 1);
			const respen = await fetch("https://en.wikipedia.org/api/rest_v1/page/summary/" + titen, options);
			if (respen.ok) {
				const datos = await respen.json();
				if (datos.thumbnail)
					txobj.images.push(datos.thumbnail.source);
				if (datos.extract)
					txobj.extract = { "en" : datos.extract };
			}
			// español
			if (txobj.wikipedia.es) {		
				const tites = txobj.wikipedia.es.slice(txobj.wikipedia.es.lastIndexOf("/") + 1);
				const respes = await fetch("https://es.wikipedia.org/api/rest_v1/page/summary/" + tites, options);
				if (respes.ok) {
					const datos = await respes.json();
					if (datos.thumbnail) {
						// guardo la imagen si no está repetida
						if (txobj.images.length == 0 || txobj.images[0] !== datos.thumbnail.source)
							txobj.images.push(datos.thumbnail.source);
					}
					if (datos.extract) {
						if (!txobj.extract)
							txobj.extract = {};		
						txobj.extract.es = datos.extract;
					}
				}
			}	
			// guardo
			wikients[tx] = txobj;
		}
		//console.log(wikients);
			
		// consolido los resultados
		for (const tx in Datos.taxones) {
			const wdiri = Datos.taxones[tx].wikidata;		
			if (wdiri !== undefined && wikients[wdiri] !== undefined)
				Object.assign(Datos.taxones[tx], wikients[wdiri]);
		}
		
		// guardo los taxones
		const blobtx =  new Blob([JSON.stringify(Datos.taxones, null, 2)], {type: "text/plain;charset=utf-8"});
		saveAs(blobtx, "taxons.json");		
		
		// guardo en la caché		
		//Crafts.cacheandoAdhoc(txurl, Datos.taxones);
		*/
    });	
}
 

// obtengo los datos de provincias
async function getProvincesInfo() {
	// miro si están las provincias en la caché
	const provurl = config.craftsConfig.api + "/object?id=misprovs";
	await Crafts.getCacheData(provurl).then(data => {
		// guardo 
		Datos.provs = data;		
    })
    .catch(async error => {
  		console.debug("No están las provincias en la caché...");
  		
		// 1) obtengo las regiones NUTS3 de Portugal y las provincias base de España
		// regiones NUTS3 de Portugal
		let nuts3 = [];
		const datos = await Crafts.getData(config.craftsConfig.queryNopars, 
			{ queryName: "portugueseNUTS3" }, true); // no la cacheo
		for (let row of datos.results.bindings) {
			// obtengo datos
			let prov = { 
				iri: row.prov.value,
				isPortuguese: true
			};
			// guardo cada resultado
			Datos.provs[prov.iri] = prov;
			nuts3.push(prov.iri);
		}
		//	provincias base de España
		let prbase = [];
		const datos2 = await Crafts.getData(config.craftsConfig.queryNopars, 
			{ queryName: "baseProvinces" }, true); // no la cacheo
		for (let row of datos2.results.bindings) {
			// obtengo datos
			let prov = { iri: row.prov.value };
			// guardo cada resultado
			Datos.provs[prov.iri] = prov;
			prbase.push(prov.iri);
		}
  		
		// 2) obtengo los datos de las regiones NUTS3 de Portugal y las provincias base de España
		
		// inicializo las promesas
		let promesas = [];	
	
		// NUTS3
	
		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs = descomponerCraftsResources('PortugueseNUTS3', nuts3);			
		// ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS		
		for (let objr of objrs) {
			// creo una promesa para cada petición
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)
					let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
					// convierto en array si es necesario
					if (!Array.isArray(datos))
						datos = [ datos ];			
					// actualizo nuts3 a nuts3
					for (let dato of datos) {
						if (dato.infoSpecies) 
							Datos.provs[dato.iri].infoSpecies = dato.infoSpecies;
						if (dato.label)
							Datos.provs[dato.iri].label = dato.label;
						if (dato.wkt)
							Datos.provs[dato.iri].geometry = parse(dato.wkt); // transformo a GeoJSON					
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
	
		// provincias base
	
		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs2 = descomponerCraftsResources('BaseProvince', prbase);			
		// ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS		
		for (let objr of objrs2) {
			// creo una promesa para cada petición
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)
					let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
					// convierto en array si es necesario
					if (!Array.isArray(datos))
						datos = [ datos ];			
					// actualizo provincia a provincia
					for (let dato of datos) {
						Object.assign(Datos.provs[dato.iri], dato);
						// reajuste geometría
						if (Datos.provs[dato.iri].wkt) {
							Datos.provs[dato.iri].geometry = parse(Datos.provs[dato.iri].wkt); // transformo a GeoJSON
							delete Datos.provs[dato.iri].wkt;
						}
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
	
		// espero a que terminen todas las promesas
		await Promise.all(promesas);	
		promesas = [];
		
		// sigo con las siguientes consultas, que antes estaban cacheadas
	
		// 3) consulta "countPlotsPerAllTaxonsProv" (LENTA)
		// obtengo todas las uris de las especies
		const txuris = Object.keys(Datos.taxones);
		// inicializo nplots de todas las especies para todas las provincias CON DATOS DE PARCELAS y por inventario
		for (let ifn of config.ifnVersions) {
			for (let pruri of prbase) {
				const prov = Datos.provs[pruri];
				if (prov[ifn]) {
					prov[ifn].nplots = {};
					for (let txuri of txuris)
						prov[ifn].nplots[txuri] = 0;
				}
			}
		}
		// una promesa con una llamada a CRAFTS por versión de inventario
		for (let ifn of config.ifnVersions) {
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)
					//const objr = { "ifn": ifn, 'ancestor': taxontop }; // versión anterior: countPlotsPerAllTaxonsProv_old
					const objr = { [ifn]: true };
					let datos = await Crafts.getData(config.craftsConfig.queryCountPlotsPerAllTaxonsProv, objr, true);
					// guardo el número de parcelas por provincia y especie
					for (let row of datos.results.bindings) {
						// obtengo datos
						const pruri = row.prov.value;
						const txuri = row.tx.value;
						const nplots = Number(row.nplots.value);	
						// y guardo número de parcelas en la provincia por especie
						const prov = Datos.provs[pruri];
						if (prov && prov[ifn] && prov[ifn].nplots) 
							prov[ifn].nplots[txuri] = nplots;
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
		// espero a que terminen todas las promesas
		await Promise.all(promesas);  		
	
		/* YA NO MUESTRO ESTA INFO (no muy relevante)
		// 4) proceso la consulta  "countTreesPerTaxonProv"	
		// inicializo ntrees para todas las provincias CON DATOS DE PARCELAS y por inventario
		for (let ifn of config.ifnVersions) {
			for (let pruri of prbase) {
				const prov = Datos.provs[pruri];
				if (prov[ifn])
					prov[ifn].ntrees = {};
			}
		}
		// una promesa con una llamada a CRAFTS por versión de inventario
		for (let ifn of config.ifnVersions) {	
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados
					const objr = { "ifn": ifn };
					let datos = await Crafts.getData(config.craftsConfig.queryCountTreesPerTaxonProv, objr);
					// guardo el número de parcelas por provincia y especie
					for (let row of datos.results.bindings) {
						// obtengo datos
						const pruri = row.prov.value;
						const txuri = row.tx.value;
						const ntrees = Number(row.ntrees.value);
						// y guardo número de árboles por especie en la provincia
						const prov = Datos.provs[pruri];
						if (prov && prov[ifn] && prov[ifn].ntrees) 
							prov[ifn].ntrees[txuri] = ntrees;
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
		// espero a que terminen todas las promesas
		await Promise.all(promesas);*/	
	
		// guardo en la caché		
		Crafts.cacheandoAdhoc(provurl, Datos.provs);
  	});
}


//////////
// PATCHES
//////////
// función clave para obtener los candidatos para cachear datos de teselas
function getCeldasTeselasCandidatas(arriba, ocgm, cz) {
	// extraigo la capa del mapa
	const maplayer = getMapLayer(cz);
	// en las capas con "areamin" no permito cachear hacia arriba
	// (de otra manera aberraciones por cambio área mínima)
	const zini = maplayer.areamin? cz : maplayer.zmin;
	// hacia abajo preinicializo al zoom máximo
	let zfin = maplayer.zmax;
	// sólo permito un máximo de 3 niveles para evitar explosión
	if (zfin > cz + 3)
		zfin = cz +3;	
	// obtengo candidatos sin incluir el zoom cz
	let objc = {};
	for (let z=zini; z<=zfin; z++) {
		// aquí es donde miro si es hacia arriba o hacia abajo
		if ( (arriba && z < cz) || (!arriba && z > cz) ) {
			if (ocgm[z]) { // sólo procedo si existe el nivel correspondiente de zoom
				objc[z] = []; // un array por nivel de zoom
				for (let x=ocgm[z].cellW; x<=ocgm[z].cellE; x++) {
					for (let y=ocgm[z].cellS; y<=ocgm[z].cellN; y++) {
						const et = 'z' + z + '_x' + x + '_y' + y;
						objc[z].push(et); // le enchufo la etiqueta
					}
				}
			}		
		}
	}
	return objc;
}
function getQueryCeldaTeselas(cellX, cellY, zoom) {
	// preparo objeto consulta celda
	const bounds = getCeldaBounds(cellX, cellY, zoom);
	// extraigo la capa del mapa
	const maplayer = getMapLayer(zoom);
	let qobj = {
		"layer" : maplayer.layer,
		"latsouth" : bounds.getSouth(),
		"latnorth" : bounds.getNorth(),
		"lngwest" : bounds.getWest(),
		"lngeast" : bounds.getEast(),
		"limit" : 10000
	};
	// restricción de areamin SÓLO PARA CAPA LOWRES
	if (maplayer.areamin) {
		const potencia = Math.pow(4, zoom - 6); // debe ser entre 4 (2D) en vez de 2 (1D)
		qobj.areamin = config.minAreaStep6 / potencia;
	}
	// devuelvo
	return qobj;
}
async function discoverPatchesInCell(objcell, sesion) {
	// preparo qobj por si tengo que hacer una petición a CRAFTS
	let qobj = getQueryCeldaTeselas(objcell.cellX, objcell.cellY, objcell.zoom);
	
	// preinicializo la celda si no existe
	if (!Datos.celdasTeselas[objcell.et])
		Datos.celdasTeselas[objcell.et] = { "pending": true };
	
	// OBTENGO CANDIDATOS PARA EL CACHEO
	// obtengo matriz de grids para esta celda (pero sólo para los zooms usados)
	const ocgm = getCeldaGridMatrix(objcell.cellX, objcell.cellY, objcell.zoom, sesion.zoomUsados);
	// aquí tengo las celdas candidatas por nivel de zoom (generales y específicas, incluyendo la etiqueta de mycell)
	const candgen = getCeldasTeselasCandidatas(true, ocgm, objcell.zoom);
	const candesp = getCeldasTeselasCandidatas(false, ocgm, objcell.zoom);
	
	// compruebo si hay que obtener las teselas de la celda
	if (Datos.celdasTeselas[objcell.et].pending) {
		// obtengo las teselas de la celda		
		// inicializo turis como un objeto para guardar las teselas recuperadas
		let turis = {};
		
		// si la celda no está en una zona válida (Iberia o Canarias) me ahorro las consultas
		let valida = false;
		const celdabounds = getCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
		for (let zona of config.zonasValidas) {
			const zonabounds = L.latLngBounds(zona);
			if (zonabounds.intersects( celdabounds ) )
				valida = true;
		}	
		if (valida) {
			// intento cachear datos
			let bingo = false;
			// para el cacheo tengo en cuenta si es la CAPA LOWRES	
			// 1) posible inferencia: tengo los datos de la celda del nivel superior (no posible en LOWRES)
			// (en la llamada a getCeldasTeselasCandidatas ya se tiene en cuenta que en LOWRES no se puede cachear de arriba)
			for (const z in candgen) {
				if (!bingo) {
					bingo = true; // inicializo para este bucle
					for (const et of candgen[z]) { // necesito todas las celdas de z
						if (!Datos.celdasTeselas[et] || Datos.celdasTeselas[et].pending) {
							bingo = false;
							break; // rompo bucle
						}
					}
					// guardo datos en caso de bingo
					if (bingo) {
						//console.info("Cacheo gen para celda " + objcell.et); // TODO
						for (const et of candgen[z]) { // necesito todas las celdas de z
							for (let turi of Datos.celdasTeselas[et]) {
								// sólo incluyo las teselas contenidas en la celda
								const tev = Datos.teselas[turi];
								if (celdabounds.getWest() <= tev.east && celdabounds.getEast() >= tev.west
										&& celdabounds.getNorth() >= tev.south && celdabounds.getSouth() <= tev.north)
									turis[turi] = true;
							}
						}
					}
				}
			}
			// 2) posible inferencia: tengo todos los datos de las celdas específicas
			if (!bingo) {
				for (const z in candesp) {
					if (!bingo) {			
						bingo = true; // inicializo para este bucle
						for (const et of candesp[z]) { // necesito todas las celdas de z
							if (!Datos.celdasTeselas[et] || Datos.celdasTeselas[et].pending) {
								bingo = false;
								break; // rompo bucle
							}
						}
						// guardo datos en caso de bingo
						if (bingo) {
							//console.info("Cacheo esp para celda " + objcell.et); // TODO
							for (const et of candesp[z]) { // necesito todas las celdas de z
								for (let turi of Datos.celdasTeselas[et]) {
									// sólo las que superen el área mínima de tenerlo
									if (!qobj.areamin || Datos.teselas[turi].area >= qobj.areamin) 
										turis[turi] = true;
								}
							}
						}
					}
				}
			}
		
			// no hubo suerte, obtengo las teselas de la celda para la primera página
			if (!bingo) {
				let indpag = 0;
				let maspags = false;
				do {
					// ajuste offset
					qobj.offset = indpag * qobj.limit;
		
					// hago la llamada a CRAFTS	y espero resultados (cacheable)
					const datos = await Crafts.getData(config.craftsConfig.queryPatchesinbox, qobj, 
						false, sesion.infoTeselas);
				
					// proceso los resultados (válido incluso con 0 resultados)
					for (let row of datos.results.bindings) {
						const { patch, poly, west, east, north, south, area } = row;
						// continue only if not blank nodes
						if (patch.type === "uri" && poly.type === "uri") {
							// obtengo uri de la tesela
							const turi = patch.value;
							// recupero datos de la tesela y guardo si no estaba antes
							if (!Datos.teselas[turi]) {
								const patchData = {
									'iri': turi,
									'poly': poly.value,
									'west': Number(west.value),
									'east': Number(east.value),
									'north': Number(north.value),
									'south': Number(south.value),
									'area': Number(area.value),
									'pending': true // marco que está pendiente recuperar sus datos
								};
								Datos.teselas[turi] = patchData;				
							}	
							// guardo la uri de la tesela
							turis[turi] = true; // si turi estuviera repetida se sobre-escribiría
						}
					}
	
					// detecto si hay más páginas
					maspags = !(datos.results.bindings.length < qobj.limit);
					// incremento el índice
					indpag++;
				} while(maspags);
			}
		}
		
		// guardo turis en mi celda
		Datos.celdasTeselas[objcell.et] = Object.keys(turis); // aquí me quedo sólo con las claves		
	}
	
	// actualizo progreso
	if (sesion.progreso && objcell.idtimeout == sesion.idTimeoutActualizar) {
		sesion.infoTeselas.celdasMediadas.push(1);
		sesion.progreso(true, sesion);
	}	

	// fue todo bien, resuelvo la promesa
	return Promise.resolve();
}
async function processPatches(idtimeout, objcells, dpcpromises, sesion) {
	// espero a que terminen las promesas de discoverPatchesInCell
	//console.time(idtimeout + " - patch discovery");
	await Promise.all(dpcpromises);
	//console.timeEnd(idtimeout + " - patch discovery");
	
	if (idtimeout != sesion.idTimeoutActualizar) 
		return;
	
	// obtengo las uris de todas las teselas
	const allturis = objcells.flatMap(objcell => Datos.celdasTeselas[objcell.et]);
		
	// ojo: puede haber duplicados ya que una tesela puede estar en varias celdas
	// no merece la pena hacer un _.uniq porque es muy lento, 
	// da igual pedir varias veces una tesela si sólo se guarda y se pinta una vez	
	
	// obtengo las teselas listas y las que no tengo datos
	const { readyturis, pendturis } = allturis.reduce((acc, turi) => {
		const tesela = Datos.teselas[turi];
		if (!tesela) return acc;
		if (!tesela.pending) acc.readyturis.push(turi);
		else acc.pendturis.push(turi);
		return acc;
	}, { readyturis: [], pendturis: [] });
	
	// obtengo el número de teselas pintadas
	const pintadas = readyturis.filter( turi => Sesion.tesPintadas[turi] ).length;
	
	// consulto en la caché por si tuviera alguna tesela
	// trabajo con misteselas, que ya tiene los datos de teselas procesados (por rendimiento)
	const [objcache, pendingturis] = getCachedObjectMapping('misteselas', pendturis);
	const cacheturis = Object.values(objcache).flat();
	
	// inicializo logging datos teselas y actualizo progreso
	if (sesion.progreso) {
		sesion.infoTeselas.teselasTotales = allturis.length;
		sesion.infoTeselas.teselasCompletadas = readyturis.length;
		sesion.infoTeselas.teselasPintadas = pintadas;
		sesion.progreso(true, sesion);
	}
	
	console.info("Extrayendo teselas. #total: " + allturis.length + " #pintadas: " + pintadas  + " #cargadas: " + readyturis.length 
		+ " #pendientes (caché): " + cacheturis.length + " #pendientes (crafts): " + pendingturis.length);
		
	// inicializo promesas y objeto con las teselas extraídas con crafts a cachear
	let promesas = [];
	let objtescachear = {};
	
	// 1) empiezo con las peticiones a CRAFTS
	if (pendingturis.length > 0) {
		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs = descomponerCraftsResources('Patch', pendingturis);	
		// permito un paralelismo de MAX_HILOS
		const pagina = Math.ceil(objrs.length/MAX_HILOS);
		for (let i=0; i<MAX_HILOS; i++) {	
			// una promesa por cada hilo
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// voy página a página (y mientras siga en la misma sesión)
					for (let j=0; j<pagina && (i + j*MAX_HILOS) < objrs.length && idtimeout == sesion.idTimeoutActualizar; j++) {
						//console.info(idtimeout + " #hilo: " + i + " #objr: " + (i + j*MAX_HILOS));							
						// inicializo teselas para el render
						const pintarturis = [];						
						// recupero objr
						const objr = objrs[i + j*MAX_HILOS];
						// hago la llamada a CRAFTS	y espero resultados (no cacheable)
						let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, 
							true, sesion.infoTeselas);
						// convierto en array si es necesario
						datos = Array.isArray(datos) ? datos : [datos];
						// y actualizo tesela a tesela
						for (let dato of datos) {
							if (Datos.teselas[dato.iri].pending) {				
								const tesela = Datos.teselas[dato.iri];
								// actualizo según el modelo de la API en CRAFTS (revisar!)
								if (dato.infoSpecies)
									tesela.infoSpecies = dato.infoSpecies;
								if (dato.province)
									tesela.province = dato.province;
								if (dato.canopyCoverTreesPercent)
									tesela.canopyCoverTreesPercent = dato.canopyCoverTreesPercent;
								if (dato.soilUse)
									tesela.soilUse = dato.soilUse;
								if (dato.infoSoil)
									tesela.infoSoil = dato.infoSoil;																
								// la geometría la resuelvo de manera especial
								if (dato.wkt) 
									tesela.geometry = parse(dato.wkt); // transformo a GeoJSON
								// adicionalmente marco si la tesela es forestal
								if (tesela.soilUse) {
									const tesusos = Array.isArray(tesela.soilUse)?tesela.soilUse : [ tesela.soilUse ];	
									tesela.forestal = Datos.usos[config.forestuse].expuris.filter(uuri => tesusos.includes(uuri)).length > 0;
								}
									
								// quito el flag de pending
								delete tesela.pending;
								
								// guardo en el objeto teselas a cachear
								objtescachear[dato.iri] = Datos.teselas[dato.iri];
								
								// guardo para pintar
								pintarturis.push(dato.iri);
							}
						}
						// actualizo progreso sólo si me toca
						if (sesion.progreso && idtimeout == sesion.idTimeoutActualizar) {
							sesion.infoTeselas.teselasCompletadas += pintarturis.length;
							sesion.progreso(true, sesion);
						}
						// render sólo si me toca de este bloque de teselas
						if (sesion.infoTeselas.pintar && idtimeout == sesion.idTimeoutActualizar) {
							sesion.infoTeselas.teselasPintadas += pintarTeselas(pintarturis);
							sesion.progreso(true, sesion);
						}
					}						
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );	
		}
	}	
	
	// 2) sigo con la caché (todo paralelo)
	const curls = Object.keys(objcache);
	if(curls.length > 0) {
		const promesaCache = Promise.all(
			curls.map(async curl => {
				try {
      				// inicializo teselas para el render
					const pintarturis = [];
					// hago la llamada a la caché
					let misteselas = await Crafts.getCacheData(curl, sesion.infoTeselas);
					// navego por las puris de objcache[curl]
					for (let puri of objcache[curl]) {
						if (Datos.teselas[puri].pending) {
							// guardo datos (ya listos)
							Datos.teselas[puri] = misteselas[puri];
							// e incluyo para pintar
							pintarturis.push(puri);
						}
					}
					// actualizo progreso sólo si me toca
					if (sesion.progreso && idtimeout == sesion.idTimeoutActualizar) {
						sesion.infoTeselas.teselasCompletadas += pintarturis.length;
						sesion.progreso(true, sesion);
					}
					// render sólo si me toca de este bloque de teselas
					if (sesion.infoTeselas.pintar && idtimeout == sesion.idTimeoutActualizar) {
						sesion.infoTeselas.teselasPintadas += pintarTeselas(pintarturis);
						sesion.progreso(true, sesion);
					}
				} catch (err) {
					console.error('Error processing URL: ', curl, err);
				}
			})
		);
		// añado a las promesas
		promesas.push(promesaCache);
	}
		
	// 3) termino con el render de las teselas listas
	// sólo hago el rendering si me toca (idtimeout es el mismo que sesion.idTimeoutActualizar)
	if (sesion.infoTeselas.pintar && idtimeout == sesion.idTimeoutActualizar) {
		// pinto teselas listas
		sesion.infoTeselas.teselasPintadas += pintarTeselas(readyturis);
		sesion.progreso(true, sesion);
	}
	
	// espero a que terminen las promesas pendientes
	//console.time(idtimeout + " - patch resources");
	await Promise.all(promesas);
	//console.log(idtimeout + " - patch resources #curls: " +curls.length);
	//console.timeEnd(idtimeout + " - patch resources");
	
	// guardo en la caché objtescachear
	//const ntc = Object.keys(objtescachear).length;
	//console.info("Cacheado ad hoc de " + ntc + " teselas");
	cacheandoAdhoc('misteselas', objtescachear);

	// aseguro pintar todas las teselas (por si vención algún timeout)
	if (sesion.infoTeselas.pintar && idtimeout == sesion.idTimeoutActualizar) {	
		// pintado restos (por si se escapó alguna con los timeouts)
		sesion.infoTeselas.teselasPintadas += pintarTeselas(pendturis);		
		sesion.progreso(true, sesion);
		//console.log("#teselas únicas: " + _.uniq(allturis).length);
		//console.log("#teselas pintadas: " + Object.keys(sesion.tesPintadas).length);
	}
	//console.log("#teselas pintadas: " + Object.keys(sesion.tesPintadas).length);
	
	
	// me salgo si saltó el timeout
	if (idtimeout != sesion.idTimeoutActualizar) 
		return;
	
	// fue todo bien, resuelvo la promesa
	return Promise.resolve();
}



////////
// PLOTS
////////

// función clave para obtener los candidatos para cachear datos de parcelas
function getCeldasParcelasCandidatas(arriba, ocgm, cz, ifn) {	
	// calculo rango de zooms permitidos
	const zini = config.zParcela;
	// hacia abajo permito un máximo de 3 niveles para evitar explosión
	const zfin = cz + 3 > config.zMaxCelda? config.zMaxCelda : cz + 3;
	// obtengo candidatos sin incluir el zoom cz
	let objc = {};
	for (let z=zini; z<=zfin; z++) {
		// aquí es donde miro si es hacia arriba o hacia abajo
		if ( (arriba && z < cz) || (!arriba && z > cz) ) {
			if (ocgm[z]) { // sólo procedo si existe el nivel correspondiente de zoom
				objc[z] = []; // un array por nivel de zoom
				for (let x=ocgm[z].cellW; x<=ocgm[z].cellE; x++) {
					for (let y=ocgm[z].cellS; y<=ocgm[z].cellN; y++) {
						const et = 'z' + z + '_x' + x + '_y' + y + '_' + ifn;
						objc[z].push(et); // le enchufo la etiqueta
					}
				}
			}		
		}
	}
	return objc;
}
function getQueryCeldaParcelas(objcell) {
	// preparo objeto consulta celda
	const bounds = getCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
	let qobj = {
		"ifn2": objcell.ifn === "ifn2",
		"ifn3": objcell.ifn === "ifn3",
		"latsouth" : bounds.getSouth(),
		"latnorth" : bounds.getNorth(),
		"lngwest" : bounds.getWest(),
		"lngeast" : bounds.getEast(),
		"limit" : 10000
	};
	return qobj;
}
// rehago "discoverPlotsInCell" como en Descarga IFN (más eficiente)
async function discoverPlotsInCell(objcell, sesion) {
	// preparo qobj por si tengo que hacer una petición a CRAFTS
	let qobj = getQueryCeldaParcelas(objcell);
	
	// preinicializo la celda si no existe
	if (!Datos.celdasParcelas[objcell.et])
		Datos.celdasParcelas[objcell.et] = { "pending": true };	
	
	// OBTENGO CANDIDATOS PARA EL CACHEO
	// obtengo matriz de grids para esta celda (pero sólo para los zooms usados)
	const ocgm = getCeldaGridMatrix(objcell.cellX, objcell.cellY, objcell.zoom, sesion.zoomUsados);
	// aquí tengo las celdas candidatas por nivel de zoom (generales y específicas, incluyendo la etiqueta de mycell)
	const candgen = getCeldasParcelasCandidatas(true, ocgm, objcell.zoom, objcell.ifn);
	const candesp = getCeldasParcelasCandidatas(false, ocgm, objcell.zoom, objcell.ifn);
	
	// compruebo si hay que obtener las parcelas de la celda
	if (Datos.celdasParcelas[objcell.et].pending) {
		// obtengo las parcelas de la celda		
		// inicializo puris como un objeto para guardar las parcelas recuperadas
		let puris = {};
		
		// si la celda no está en una zona válida (Iberia o Canarias) me ahorro las consultas
		let valida = false;
		const celdabounds = getCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
		for (let zona of config.zonasValidas) {
			const zonabounds = L.latLngBounds(zona);
			if (zonabounds.intersects( celdabounds ) )
				valida = true;
		}
		if (valida) {
			// intento cachear datos
			let bingo = false;
			// 1) posible inferencia: tengo los datos de la celda del nivel superior
			for (const z in candgen) {
				if (!bingo) {
					bingo = true; // inicializo para este bucle
					for (const et of candgen[z]) { // necesito todas las celdas de z
						if (!Datos.celdasParcelas[et] || Datos.celdasParcelas[et].pending) {
							bingo = false;
							break; // rompo bucle
						}
					}
					// guardo datos en caso de bingo
					if (bingo) {
						//console.info("Cacheo gen para celda " + objcell.et); //
						for (const et of candgen[z]) { // necesito todas las celdas de z
							for (let puri of Datos.celdasParcelas[et]) {
								// sólo incluyo las parcelas contenidas en la celda								
								const pev = Datos.parcelas[puri];
								if (celdabounds.getWest() <= pev.lng && celdabounds.getEast() >= pev.lng
										&& celdabounds.getNorth() >= pev.lat && celdabounds.getSouth() <= pev.lat)
									puris[puri] = true;
							}
						}
					}
				}
			}
			// 2) posible inferencia: tengo todos los datos de las celdas específicas
			if (!bingo) {
				for (const z in candesp) {
					if (!bingo) {			
						bingo = true; // inicializo para este bucle
						for (const et of candesp[z]) { // necesito todas las celdas de z
							if (!Datos.celdasParcelas[et] || Datos.celdasParcelas[et].pending) {
								bingo = false;
								break; // rompo bucle
							}
						}
						// guardo datos en caso de bingo
						if (bingo) {
							//console.info("Cacheo esp para celda " + objcell.et); //
							for (const et of candesp[z]) { // necesito todas las celdas de z
								for (let puri of Datos.celdasParcelas[et])
									puris[puri] = true;
							}
						}
					}
				}
			}
		
			// no hubo suerte, obtengo las parcelas de la celda para la primera página
			if (!bingo) {			
				//console.log(objcell.et + " - obteniendo lista de parcelas..."); // TODO			
				let indpag = 0;
				let maspags = false;
				// defino los nombres de variables según la versión del inventario
				const pvar = "plot" + objcell.ifn;
				const potrovar = config.ifnVersions[0] === objcell.ifn? "plot" + config.ifnVersions[1] : "plot" + config.ifnVersions[0];
				do {
					// ajuste offset
					qobj.offset = indpag * qobj.limit;
		
					// hago la llamada a CRAFTS	y espero resultados (cacheable)
					const datos = await Crafts.getData(config.craftsConfig.queryPlotsinbox, qobj,
						false, sesion.infoParcelas);
				
					// proceso los resultados (válido incluso con 0 resultados)
					for (let row of datos.results.bindings) {
						// continue only if not blank nodes
						if (row[pvar].type === "uri") {
							const puri = row[pvar].value;
							// inicializo parcela si no existe
							if (!Datos.parcelas[puri])
								Datos.parcelas[puri] = { 'iri': puri };
							if (!Datos.parcelas[puri].lat) {
								// cubre también el caso en que existe la parcela, pero falta esta info básica
								// (si se extrayeron los datos de los árboles desde otra parcela anterior o siguiente)
								Datos.parcelas[puri].lat = Number(row.lat.value),
								Datos.parcelas[puri].lng = Number(row.lng.value);
								Datos.parcelas[puri].ifn = objcell.ifn;
								Datos.parcelas[puri].prov = row.prov.value;
								Datos.parcelas[puri].nt = {};
								Datos.parcelas[puri].ba = {};
								Datos.parcelas[puri].vwb = {};
								Datos.parcelas[puri].vwob = {};
								if (row[potrovar])
									Datos.parcelas[puri][potrovar] = row[potrovar].value;
								if (row.dataCapture)
									Datos.parcelas[puri].dataCapture = row.dataCapture.value;		
							}							
							// guardo la cuenta de especies de la fila (si existe)
							if (row.species) {
								const species = row.species.value;
								const nt = Number(row.nt.value);
								Datos.parcelas[puri].nt[species] = nt;
								const ba = Number(row.ba.value);
								Datos.parcelas[puri].ba[species] = ba;
								let vwb = Number(row.vwb.value);
								let vwob = Number(row.vwob.value);
								// apaño por el error en la conversión del IFN2
								if (vwb < vwob) {
									vwb = vwob;
									vwob = Number(row.vwb.value);
								}
								Datos.parcelas[puri].vwb[species] = vwb;
								Datos.parcelas[puri].vwob[species] = vwob;
							}
							// guardo la uri de la parcela
							puris[puri] = true; // si puri estuviera repetida se sobre-escribiría							
						}
					}
	
					// detecto si hay más páginas
					maspags = !(datos.results.bindings.length < qobj.limit);
					// incremento el índice
					indpag++;
				} while(maspags);
			}
		}
		
		// guardo puris en mi celda
		Datos.celdasParcelas[objcell.et] = Object.keys(puris); // aquí me quedo sólo con las claves		
	}
	
	//console.log(objcell.et + " - #parcelas: " + Datos.celdasParcelas[objcell.et].length); // TODO
	
	// me salgo si saltó el timeout
	if (objcell.idtimeout != sesion.idTimeoutActualizar) 
		return;
		
	// actualizo estadísticos y progreso
	sesion.infoParcelas.celdasCompletadas.push(1);
	sesion.infoParcelas.parcelasCompletadas.push(Datos.celdasParcelas[objcell.et].length);
	if (sesion.progreso)
		sesion.progreso(true, sesion);	

	// pinto las parcelas si estoy en modo parcela (no árbol)
	if (sesion.infoParcelas.pintar && !sesion.infoParcelas.modoArbol)
		pintarParcelas(Datos.celdasParcelas[objcell.et]); 

	// fue todo bien
	if (!sesion.infoParcelas.modoArbol) // resuelvo la promesa en modo parcela
		return Promise.resolve();
	else // en modo árbol hay que recuperarlos
		await processTrees(objcell.idtimeout, Datos.celdasParcelas[objcell.et], objcell.ifn, sesion);
}

async function processTrees(idtimeout, allpuris, ifn, sesion) {	
	////////////////////////////
	// EXTRACCIÓN ÁRBOLES
	
	// si estoy en modo pintar extraigo los árboles de todos los inventarios	
	// en otro caso, sólo los del inventario ifn
	
	// obtengo las puris por inventario
	let purisifn = {};
	for (let ifnev of config.ifnVersions) {
		if (ifnev === ifn)
			purisifn[ifnev] = allpuris;
		else if (sesion.infoParcelas.pintar) {
			purisifn[ifnev] = [];
			for (let puri of allpuris) {
				if (Datos.parcelas[puri]["plot"+ifnev])
					purisifn[ifnev].push(Datos.parcelas[puri]["plot"+ifnev]);				
			}
		}
	}
	
	// extracción de datos	
	for (let ind = 0; ind < config.ifnVersions.length; ind++) {
		let ifnev = config.ifnVersions[ind];
		if (purisifn[ifnev] && purisifn[ifnev].length > 0) {
			// recupero las uris de las parcelas
			let purisev = purisifn[ifnev];
			
			// obtengo las parcelas listas y las que no tienen datos de árboles
			let { readypuris, pendpuris } = purisev.reduce((acc, puri) => {
				const parcela = Datos.parcelas[puri];
				if (!parcela) 
					acc.pendpuris.push(puri); // no existe, pero puedo pedir sus árboles
				else if (parcela.arbs) 
					acc.readypuris.push(puri);
				else
					acc.pendpuris.push(puri);
				return acc;
			}, { readypuris: [], pendpuris: [] });
		
			// consulto en la caché por si tuviera alguna parcela
			const [objcache, pendingpuris] = getCachedObjectMapping('treesinplots', pendpuris);
			const cachepuris = Object.values(objcache).flat();
		
			///////////////////////
			// LLAMADA treesinplots
			console.info("Extrayendo árboles de parcelas "+ ifnev + ". #total parcelas: " + purisev.length + " #cargadas: " + readypuris.length 
				+ " #pendientes (caché): " + cachepuris.length + " #pendientes (crafts): " + pendingpuris.length);
		
			//inicializo las promesas
			let promesas = [];
	
			// 1) empiezo con las peticiones a CRAFTS
			if (pendingpuris.length > 0) {
				// hago llamadas con lotes de 60 uris
				const lote = 60;
				const pagina = Math.ceil(pendingpuris.length/(lote*MAX_HILOS));
				//console.info(idtimeout + " #count parcelas pendientes: " + pendingpuris.length + " tam pagina: " + pagina);	
				for (let i=0; i<MAX_HILOS; i++) {	
					// una promesa por cada hilo
					promesas.push( new Promise(async function(resolve, reject) {
						try {				
							// voy página a página (y mientras no salte el timeout)
							for (let j=0; j<pagina && lote*(i + j*MAX_HILOS) < pendingpuris.length && idtimeout == sesion.idTimeoutActualizar; j++) {
								//console.info(idtimeout + " #hilo: " + i + " #ind: " + lote*(i + j*MAX_HILOS));						
					
								// inicializo objeto de la petición a CRAFTS
								let objr = {
									piris: pendingpuris.slice(lote*(i + j*MAX_HILOS), lote*(1 + i + j*MAX_HILOS)),
									ifn: ifnev
								};
								// hago la llamada a CRAFTS	y espero resultados (cacheable)
								const datos = await Crafts.getData(config.craftsConfig.queryTreesinplots, objr,
									false, sesion.infoParcelas);							
								// inicializo el array de árboles por parcela (ya que ha habido respuesta buena)
								for (let puri of objr.piris) {
									// si no existiera, inicializo la parcela
									if (!Datos.parcelas[puri])
										Datos.parcelas[puri] = { iri : puri };
									// inicializo
									Datos.parcelas[puri].arbs = [];
								}
								// extraigo los resultados
								for (let row of datos.results.bindings) {
									// preparo los datos del árbol
									let tree = {
										'iri': row.tree.value,
										'plot': row.plot.value,
										'lat': Number(row.lat.value),
										'lng': Number(row.lng.value),
										"dbh1mm": Number(row.dbh1mm.value),
										"dbh2mm": Number(row.dbh2mm.value),
										"heightM": Number(row.heightM.value)
									};
									if (row.species)
										tree.species = row.species.value;
									if (row.dataCapture)
										tree.dataCapture = row.dataCapture.value;
									if (row.treeprev) // TODO: en casos MUY RAROS podría haber varios, así sólo guarda uno (https://github.com/SemanticForest/ifn2/issues/12)
										tree["tree"+config.ifnVersions[ind-1]] = row.treeprev.value;
									if (row.treenext) // TODO: en casos MUY RAROS podría haber varios, así sólo guarda uno (https://github.com/SemanticForest/ifn2/issues/12)
										tree["tree"+config.ifnVersions[ind+1]] = row.treenext.value;
									// guardo
									if (!Datos.arboles[tree.iri])
										Datos.arboles[tree.iri] = tree;
									// evito duplicados
									if (!Datos.parcelas[tree.plot].arbs.includes(tree.iri))
										Datos.parcelas[tree.plot].arbs.push(tree.iri);
								}
							}
							// resuelvo la promesa
							resolve(true);
						} catch(err) {
							reject(err);
						}
					}) );
				}
			}

			// 2) sigo con la caché (todo paralelo)
			let curls = Object.keys(objcache);
			if(curls.length > 0) {
				const promesaCache = Promise.all(
					curls.map(async curl => {
						try {
							// hago la llamada a la caché
							let datos = await Crafts.getCacheData(curl, sesion.infoParcelas);
							// inicializo las parcelas a tratar
							let lotepuris = [];
							for (let puri of objcache[curl]) {
								// si no existiera, inicializo la parcela
								if (!Datos.parcelas[puri])
									Datos.parcelas[puri] = { iri : puri };
								if (!Datos.parcelas[puri].arbs) {// me aseguro de nuevo
									lotepuris.push(puri);
									Datos.parcelas[puri].arbs = [];
								}
							}
							// extraigo los resultados
							for (let row of datos.results.bindings) {
								// obtengo datos
								let tree = {
									'iri': row.tree.value,
									'plot': row.plot.value,
									'lat': Number(row.lat.value),
									'lng': Number(row.lng.value),
									"dbh1mm": Number(row.dbh1mm.value),
									"dbh2mm": Number(row.dbh2mm.value),
									"heightM": Number(row.heightM.value)
								};
								if (row.species)
									tree.species = row.species.value;
								if (row.treeprev) // TODO: en casos MUY RAROS podría haber varios, así sólo guarda uno (https://github.com/SemanticForest/ifn2/issues/12)
									tree["tree"+config.ifnVersions[ind-1]] = row.treeprev.value;
								if (row.treenext) // TODO: en casos MUY RAROS podría haber varios, así sólo guarda uno (https://github.com/SemanticForest/ifn2/issues/12)
									tree["tree"+config.ifnVersions[ind+1]] = row.treenext.value;
								// sólo guardo si es una de las parcelas del lote
								if (lotepuris.includes(tree.plot)) {
									if (!Datos.arboles[tree.iri])
										Datos.arboles[tree.iri] = tree;
									// evito duplicados
									if (!Datos.parcelas[tree.plot].arbs.includes(tree.iri))
										Datos.parcelas[tree.plot].arbs.push(tree.iri);					
								}
							}
						} catch (err) {
							console.error('Error processing URL: ', curl, err);
						}
					})
				);
				// añado a las promesas
				promesas.push(promesaCache);
			}

			// espero a que terminen las promesas pendientes
			await Promise.all(promesas);

			// me salgo si saltó el timeout
			if (idtimeout != sesion.idTimeoutActualizar) 
				return;
		}
	}
	
	// me salgo si saltó el timeout
	if (idtimeout != sesion.idTimeoutActualizar) 
		return;
		
	// actualizo estadísticos y progreso
	sesion.infoParcelas.celdasArbolesCompletadas.push(1);
	sesion.infoParcelas.parcelasArbolesCompletadas.push(allpuris.length);
	if (sesion.progreso)
		sesion.progreso(true, sesion);

	// pinto los árboles
	if (sesion.infoParcelas.pintar)
		pintarArboles(allpuris);
		
	// fue todo bien, resuelvo la promesa
	return Promise.resolve();
}


async function getPlotinfo(piri, ifn, logUrls) {
	if (!Datos.parcinfos[piri]) {
		const objr = { id: "PlotInfo" + ifn, iri: piri };	
		Datos.parcinfos[piri] = await Crafts.getData(config.craftsConfig.resourceTemplate, objr);
		if (logUrls)
			logUrls.red++;
		return;
	}
	if (logUrls)
		logUrls.cache++;
}

export { getUsesInfo, getTaxonsInfo, getProvincesInfo, discoverPatchesInCell, processPatches, 
	discoverPlotsInCell, getPlotinfo };